// extracted by mini-css-extract-plugin
export default {"textarea":"Textarea--textarea--7809bd","fullBorder":"Textarea--fullBorder--e30e5c"};